import { call, put, takeEvery } from 'redux-saga/effects';
import { requestApi2 } from '../../../../lib/request';
import showAlertSaga from '../../../../utilities/alert';
import { showLoading } from '../loading';
import {
  postServiceCompanyOrderFail,
  postServiceCompanyOrderSuccess,
} from './actions';
import { constants, services } from './config';

function* postServiceCompanyOrderWorker(action) {
  try {
    yield put(showLoading(true));
    const response = yield call(requestApi2, services.postServiceCompanyOrder(action.payload), ['version']);
    if (response && response.status >= 200 && response.status < 300) {
      const res = response.data.order;
      res.status = 'success';
      yield put(showLoading(false));
      yield put(postServiceCompanyOrderSuccess(res));
    } else {
      yield put(showLoading(false));
      throw response;
    }
  } catch (error) {
    yield put(postServiceCompanyOrderFail(error));
    yield put(showLoading(false));
    yield showAlertSaga({
      error: error.status,
      color: 'red',
      message: window.intl.formatMessage({
        id: error?.message || 'error.generic',
      }),
    });
  }
}

export default function* serviceCompanyOrderSaga() {
  yield takeEvery(constants.POST_SERVICE_COMPANY_ORDER, postServiceCompanyOrderWorker);
}
